import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../Button';

const propTypes = {
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  timeout: PropTypes.number,
  dismissible: PropTypes.bool,
  onDismiss: PropTypes.func,
};

const FloatingAlert = ({
  message,
  timeout = 5000,
  dismissible = true,
  onDismiss,
}) => {
  const [visible, setVisible] = useState(!!message);
  const messageTimeout = useRef();

  useEffect(() => {
    if (message) {
      if (messageTimeout.current) {
        clearTimeout(messageTimeout.current);
      }

      if (dismissible) {
        messageTimeout.current = setTimeout(() => {
          setVisible(false);
          onDismiss?.();
        }, timeout);
      }

      setVisible(true);
    }
  }, [message]);

  const classes = classNames({
    'floating-alert': true,
    'd-none': !visible,
  });

  return (
    <div className={classes}>
      {message}
      {dismissible && (
        <Button
          btnStyle="reset"
          onClick={() => {
            setVisible(false);
            onDismiss?.();
          }}
        >
          &times;
        </Button>
      )}
    </div>
  );
};

FloatingAlert.propTypes = propTypes;
export default FloatingAlert;
